export enum MajorMoneyGoals {
    PAY_OFF_DEBT = 'PAY_OFF_DEBT',
    TRAVEL = 'TRAVEL',
    BUY_A_HOUSE = 'BUY_A_HOUSE',
    BUY_A_CAR = 'BUY_A_CAR',
    KIDS_EDUCATION = 'KIDS_EDUCATION',
    RETIRE_EARLY = 'RETIRE_EARLY',
    SOMETHING_ELSE = 'SOMETHING_ELSE',
}

export enum FruitfulGoalType {
    GET_OUT_OF_DEBT = 'GET_OUT_OF_DEBT',
    NEED_BUDGET_SYSTEM = 'NEED_BUDGET_SYSTEM',
    SUPERCHARGE_GOALS = 'SUPERCHARGE_GOALS',
    OPTIMIZE_INVESTMENTS = 'OPTIMIZE_INVESTMENTS',
    DONT_KNOW_WHERE_TO_START = 'DONT_KNOW_WHERE_TO_START',
}
